"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classNameGenerator = require("../../theming/classNameGenerator");
var _default = exports["default"] = (0, _classNameGenerator.generateComponentClassNames)({
  component: 'ListItemBoxText',
  children: ['Wrapper', 'Text', 'SecondaryText']
});